<template>
  <section class="listing">
    <div class="header">
      <div class="title">Assinaturas</div>
      <!-- <button @click="$router.push('/signature/new')" class="button-new"><i class="fas fa-plus"></i><span>NOVO</span></button> -->
    </div>
    <form @submit.prevent class="form form-search">
      <input v-model="search" type="text" placeholder="Pesquisar..." />
    </form>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading">
        <div class="sum-group">
          <div class="sum">
            <span>Assinaturas</span>
            <span>{{ signatures.length }}</span>
          </div>
          <div class="sum sum2">
            <span>Profit</span>
            <span>{{ profit.length }}</span>
          </div>
          <div class="sum">
            <span>NinjaTrader</span>
            <span>{{ ninja.length }}</span>
          </div>
          <div class="sum sum2">
            <span>BlackArrow</span>
            <span>{{ black.length }}</span>
          </div>
          <div class="sum">
            <span>TraddingView</span>
            <span>{{ tradding.length }}</span>
          </div>


        </div>

        <div v-for="p in filtered" :key="p.id" class="list" :style="`background-color: ${getBackColor(p)}`">
          <div class="data">
            <div class="main-data">{{ p.user }}</div>
            <div class="detail-data">{{ p.product }} - R$ {{ p.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
          </div>
          <div style="text-align: right;margin-right: 20px;">
            <div class="main-data">{{ p.active ? 'ATIVA' : 'INATIVA' }}</div>
            <div class="detail-data">{{ p.active ? 'Próximo Vencimento ' : p.nextDate ? 'Venceu em ' : ' - '}}{{ p.nextDate }}</div>
          </div>
          <div class="actions">
            <!-- <button  @click="remove(p.id)" class="button-action" style="margin-right: 5px"><i class="fas fa-trash-alt"></i><span>EXCLUIR</span></button> -->
            <button @click="$router.push(`/signature/${p.id}`)" class="button-action"><i class="fas fa-pen"></i><span>ALTERAR</span></button>
          </div>
        </div>
      </div>
    </transition>
    <Signature v-if="signature" :id="signature" :signatureData="signatureData" />
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll, remove } from '../api/signature'
import Signature from './Signature.vue'

export default {
  name: 'signatures',
  components: { Signature },
  props: ['id'],
  data () {
    return {
      loading: true,
      signature: null,
      search: '',
      signatures: [],
      signatureData: null
    }
  },
  computed: {
    profit () {
      return this.filtered.filter(x => x.profit === true)
    },
    ninja () {
      return this.filtered.filter(x => x.ninja === true)
    },
    black () {
      return this.filtered.filter(x => x.black === true)
    },
    tradding () {
      return this.filtered.filter(x => x.black === false && x.ninja === false && x.profit === false)
    },
    filtered () {
      return this.signatures.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    }
  },
  watch: {
    async '$route' (value) {
      this.signature = value.params['id'] || null
      // Update list
      if (!value.params['id']) {
        this.getData()
      } else {
        this.signatureData = this.signatures.find(x => x.id === Number(value.params['id']))
      }
    }
  },
  async mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      try {
        this.signature = this.id || null
        this.signatures = await getAll()
        this.loading = false
      } catch (error) {
        logger.error(error, this)
      }
    },
    getBackColor (item) {
      return !item.valid ? '#e5e5e5' : item.valid === 3 ? '#c3f9ae' : item.valid === 2 ? '#f0f89c' : '#fad2d2'
    },
    async remove (id) {
      try {
        if (this.loading) return false
        this.loading = true
        // Update user
        await remove(id)
        this.loading = false
        this.getData()
      } catch (error) {
        logger.error(error, this)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.list {
  border: 1px solid #918f8f; //#918f8f
}

.sum-group {
  display: flex;
  flex-wrap: wrap;
  .sum {
    display: flex;
    flex-basis: calc(100% - 10px);
    margin: 0 5px 10px;
    span {
      text-align: center;
      padding: 8px 0;
      flex-basis: 50%;
    }
    span:nth-child(1) {
      color: #fff;
      background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
      border-radius: 5px 0 0 5px;
      border: 1px solid $secondary-color;
    }
    span:nth-child(2) {
      font-weight: bold;
      color: $secondary-color;
      border-radius: 0 5px 5px 0;
      border: 1px solid $secondary-color;
    }
  }
  .sum2 {
    span:nth-child(1) {
      color: #555;
      background: #e5e5e5;
      border: 1px solid #555;
      border-right: none;
      font-weight: bold;
    }
    span:nth-child(2) {
      color: #555;
      border: 1px solid #555;
    }
  }
}
// Desktop
@media screen and (min-width: $desktop-width) {
  .sum-group {
    .sum {
      flex-basis: calc(50% - 10px);
    }
  }
}
</style>
